import React from "react";
import ATSInquiry from "../Inquiry/ATSInquiry";
import CustomerAndFabricSalesInquiry from "../Inquiry/CustomerAndFabricSalesInquiry";
import CustomerCurrentAgingInquiry from "../Inquiry/CustomerCurrentAgingInquiry";
import CustomerInfoInquiry from "../Inquiry/CustomerInfoInquiry";
import CustomerOnOrderInquiry from "../Inquiry/CustomerOnOrderInquiry";
import CustomerRecentFabricInquiry from "../Inquiry/CustomerRecentFabricInquiry";
import CustomerStatisticsInquiry from "../Inquiry/CustomerStatisticsInquiry";
import CustomerTransactionInquiry from "../Inquiry/CustomerTransactionInquiry";
import FabricStyleCurrentInventoryInquiry from "../Inquiry/FabricStyleCurrentInventoryInquiry";
import FabricStyleInventoryPositionInquiry from "../Inquiry/FabricStyleInventoryPositionInquiry";
import FabricStylePurchaseHistoryInquiry from "../Inquiry/FabricStylePurchaseHistoryInquiry";
import VendorOnOrderInquiry from "../Inquiry/VendorOnOrderInquiry";
import VendorPurchaseHistoryInquiry from "../Inquiry/VendorPurchaseHistoryInquiry";
import SalesAndPurchaseDetailsInquiry from "./SalesAndPurchaseDetailsInquiry";
import SalesPriceInquiry from "./SalesPriceInquiry";

/* VendorOnOrder Inquiry */
export const PopupVendorOnOrderInq = (props) => {
  return (
    <VendorOnOrderInquiry
      vendorCode={props.vendorCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* VendorOnOrder PurchaseHistory */
export const PopupVendorPurchaseHistoryInq = (props) => {
  return (
    <VendorPurchaseHistoryInquiry
      vendorCode={props.vendorCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CustomerOnOrder Inquiry */
export const PopupCustomerOnOrderInq = (props) => {
  return (
    <CustomerOnOrderInquiry
      customerCode={props.customerCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CustomerTransactions Inquiry */
export const PopupCustomerTransactionsInq = (props) => {
  return (
    <CustomerTransactionInquiry
      customerCode={props.customerCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CustomerStatistics Inquiry */
export const PopupCustomerStatisticsInq = (props) => {
  return (
    <CustomerStatisticsInquiry
      customerCode={props.customerCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CustomerSalesHistory Inquiry */
export const PopupCustomerSalesHistoryInq = (props) => {
  return (
    <CustomerAndFabricSalesInquiry
      customerCode={props.customerCode}
      fabricCode={props.fabricCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CustomerMostRecentFabrics Inquiry */
export const PopupCustomerMostRecentFabricsInq = (props) => {
  return (
    <CustomerRecentFabricInquiry
      customerCode={props.customerCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CustomerCurrentAging Inquiry */
export const PopupCustomerCurrentAgingInq = (props) => {
  return (
    <CustomerCurrentAgingInquiry
      customerCode={props.customerCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* CustomerInfo Inquiry */
export const PopUpCustomerInfoInq = (props) => {
  return (
    <CustomerInfoInquiry
      customerCode={props.customerCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Fabric Purchase History Inquiry */
export const PopupFabricPurchaseHistoryInq = (props) => {
  return (
    <FabricStylePurchaseHistoryInquiry
      fabricStyleCode={props.fabricCode}
      vendorCode={props.vendorCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Fabric Inventory Position Inquiry */
export const PopupFabricInventoryPositionInq = (props) => {
  return (
    <FabricStyleInventoryPositionInquiry
      fabricStyleCode={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* FabricStyle Current Inventory Inquiry */
export const PopupItemCurrentInventoryInq = (props) => {
  return (
    <FabricStyleCurrentInventoryInquiry
      fabricStyleCode={props.code}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* FabricStyle ATS Inquiry */
export const PopupAtsInq = (props) => {
  return (
    <ATSInquiry
      fabricCode={props.code}
      fabricName={props.fabricName}
      colorCode={props.colorCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Customer Sales & Purchase Details Inquiry */
export const PopupPurchaseAndSlesDetailsInq = (props) => {
  return (
    <SalesAndPurchaseDetailsInquiry
      customerCode={props.customerCode}
      vendorCode={props.vendorCode}
      fabricStyleCode={props.fabricStyleCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};

/* Item Sales Details Inquiry */  
export const PopupSalesPriceInq = (props) => {
  return (
    <SalesPriceInquiry
      fabricStyleCode={props.fabricStyleCode}
      customerCode={props.customerCode}
      colorCode = {props.colorCode}
      isSpecialViewMode={true}
      onModuleExit={props.onModuleExit}
    />
  );
};
  

